module.exports = __webpack_public_path__ + "static/award2-838aee6615c2799ef6ff790fd3c6e144.png";